import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, Sparkles, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";
import aiInsightsImage from "@/assets/ai-insights-40s.jpg";

// Personality: Quiet intelligence — deep neutral, single spotlight, subtle sparkles, understated.
const AuraLanding = () => {
  return (
    <div className="min-h-screen bg-[hsl(220,15%,10%)] text-[hsl(30,25%,95%)]">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <section className="container mx-auto px-6 pt-16 pb-24 text-center max-w-4xl">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.4em] text-white/60 mb-8">
          <Sparkles className="h-3 w-3 animate-pulse" />
          Aura AI
          <Sparkles className="h-3 w-3 animate-pulse" />
        </div>
        <h1 className="text-5xl md:text-8xl leading-[1.02] tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
          The quietly clever companion for everything you're feeling.
        </h1>
        <p className="mt-10 text-lg text-white/70 leading-relaxed max-w-2xl mx-auto">
          Aura reads the patterns in what you track, connects them to what science actually knows,
          and offers the next small thing worth trying. No hype. No noise. Just insight.
        </p>
      </section>

      <section className="container mx-auto px-6 pb-24">
        <div className="relative aspect-[16/9] overflow-hidden rounded-2xl">
          <img src={aiInsightsImage} alt="Aura" className="w-full h-full object-cover opacity-90" />
          <div className="absolute inset-0 bg-gradient-to-t from-[hsl(220,15%,10%)] via-transparent to-transparent" />
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24 grid md:grid-cols-3 gap-12">
        {[
          { t: "Patterns you'd miss", d: "Correlations across sleep, mood, cycle and stress that only surface over weeks." },
          { t: "Science-informed", d: "Grounded in menopause research — never fabricated, never overconfident." },
          { t: "Yours alone", d: "Nothing you share leaves your account. Your body's story is not our product." },
        ].map((f) => (
          <div key={f.t} className="border-t border-white/15 pt-5">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">{f.t}</p>
            <p className="text-lg text-white/80 leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{f.d}</p>
          </div>
        ))}
      </section>

      <section className="container mx-auto px-6 pb-24 text-center">
        <Button asChild size="lg" className="px-10 py-6 text-lg bg-white text-[hsl(220,15%,10%)] hover:bg-white/90">
          <Link to="/insights"><TrendingUp className="mr-2 h-5 w-5" /> See your insights <ArrowRight className="ml-2 h-5 w-5" /></Link>
        </Button>
      </section>

      <div className="bg-background text-foreground"><Footer /></div>
    </div>
  );
};
export default AuraLanding;
